import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import ManagerStepper from '../../components/molecules/ManagerStepper';
import ShoppingCart from '../../components/molecules/ShoppingCart';
import { ViewRoot, ViewContent, ViewContentCenter, ViewSidebar } from '../../layout/Main/styled';
import { saveCurrentStep, updateValidForm, updateValidStep } from '../../features/stepper/stepper-slice';
import { dynamicCustomEventTracking } from '../../lib/gtm';
import QuickAccessForm from '../../components/molecules/QuickAccessForm';

const QuickAccess = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(saveCurrentStep('quickAccess'));
    dispatch(updateValidForm({ quickAccess: { valid: false } }));
    dispatch(updateValidStep({ quickAccess: false }));
    dynamicCustomEventTracking.send({ dynamicEventName: 'journey_quick_access_ag' });
  }, []);
  return (
    <>
      <ViewRoot>
        <ViewContent className="ViewContent">
          <ViewContentCenter>
            <QuickAccessForm />
            <ManagerStepper />
          </ViewContentCenter>
        </ViewContent>
        <ViewSidebar component="aside" className="ViewSidebar">
          <ShoppingCart />
        </ViewSidebar>
      </ViewRoot>
    </>
  );
};

export default QuickAccess;
